<template>
  <transition name="sticker">
    <SsButton2
      v-show="visible"
      class="testv__BackToTop"
      :style="{'--sticker': `url(${currentSticker})`}"
      type="text"
      @click="onClick">
      <i class="sticker"/>
    </SsButton2>
  </transition>
</template>

<script>
import throttle from 'lodash/throttle'
export default {
  name: 'TestvBackToTop',

  props: {
    stickers: Array
  },

  data () {
    return {
      visible: false,
      currentSticker: ''
    }
  },

  methods: {
    getRandomSticker (min, max) {
      min = Math.ceil(min)
      max = Math.floor(max)
      const num = Math.floor(Math.random() * (max - min + 1)) + min
      this.currentSticker = this.stickers[num]
    },
    onClick () {
      window.scrollTo({
        top: 0,
        behavior: 'smooth'
      })
    },
    toggleVisible: throttle(function () {
      const scrollHeight = document.documentElement.scrollHeight
      if (scrollHeight > window.innerHeight && window.scrollY > 200) {
        this.visible = true
      } else {
        this.visible = false
      }
    })
  },

  watch: {
    $route () {
      this.getRandomSticker(0, this.stickers.length)
    },
    stickers: {
      immediate: true,
      handler () {
        this.getRandomSticker(0, this.stickers.length)
      }
    }
  },

  mounted () {
    this.getRandomSticker(1, 14)
    this.toggleVisible()
    window.addEventListener('scroll', this.toggleVisible)
  },

  destroyed () {
    window.removeEventListener('scroll', this.toggleVisible)
  }
}
</script>

<style lang="stylus" scoped>
.testv__BackToTop {
  background: transparent;
  &:active {
    transition: all .2s ease;
    transform: translateY(10px);
  }
}
.sticker {
  display: block;
  width: 64px;
  height: 64px;
  background-size: contain;
  background-position: center;
  background-repeat: no-repeat;
  background-image: var(--sticker);
}

.sticker-enter-active,
.sticker-leave-active {
  transition: all .3s ease;
  opacity: 1;
  transform: translateY(0px);
}
.sticker-enter
.sticker-leave-to {
  opacity: 0;
  transform: translateY(64px);
}
</style>
